import { jsx } from "react/jsx-runtime";
import { Divider as Divider$1 } from "antd";
const Divider = ({ children }) => {
  return /* @__PURE__ */ jsx(Divider$1, { children });
};
export {
  Divider as default
};
